import { MouseEvent, ReactElement } from 'react';

import HasPermission from '@/components/HasPermission';
import Table from '@/common/Table';
import { TrainingQuestionsTypes } from '@/features/Settings/pages/Questions/types';
import { useQuestionsState } from '@/features/Settings/pages/Questions';

export const QuestionsTableHeader = (): ReactElement => {
  const [{ sortBy, sortDirection }, setState] = useQuestionsState(({ state, setState }) => [
    {
      sortBy: state.table.sorting.column,
      sortDirection: state.table.sorting.direction,
    },
    setState,
  ]);

  const handleSort =
    (column: string) =>
    (event: MouseEvent): void => {
      event.preventDefault();
      event.stopPropagation();
      const isSameColumn = sortBy === column;
      let newDirection: 'asc' | 'desc' | undefined;
      if (!isSameColumn) {
        newDirection = 'asc';
      } else if (sortDirection === 'asc') {
        newDirection = 'desc';
      } else if (sortDirection === 'desc') {
        newDirection = undefined;
      } else {
        newDirection = 'asc';
      }
      setState((current) => ({
        ...current,
        table: { ...current.table, sorting: { column, direction: newDirection } },
      }));
    };

  const sorting = (
    key: string
  ): { direction: TrainingQuestionsTypes.Table['sorting']['direction']; onSort: (event: MouseEvent) => void } => ({
    direction: sortBy === key ? sortDirection : undefined,
    onSort: handleSort(key),
  });

  return (
    <Table.Row header>
      <Table.Cell className="DRAG" />
      <Table.Cell className="ITEM" sorting={sorting('helperText')}>
        ITEM
      </Table.Cell>
      <Table.Cell className="CATEGORY">CATEGORY</Table.Cell>
      <HasPermission name="allowEditTrainingSettings">
        <Table.Cell className="ACTIONS">ACTIONS</Table.Cell>
      </HasPermission>
    </Table.Row>
  );
};
